import {inject, Injectable, signal} from '@angular/core';
import {firstElm} from '../../common/utils';
import {KlntHasura} from '../../core/hasura-client';
import {AuthService} from '../../core/auth.service';

export interface Round {
    id: string;
    open: Date;
    close: Date;
    appOpen: Date;
    appClose: Date;
    refClose: Date;
    appOpened: boolean;
    round: string;
    config?: any;
    compound: string;
}

const modifyConfig = (config: any): any => {
    const move_in_period_fn = (config: any) => {
        const {ug, pg} = config.eligible;
        const movein = [];
        if (!!ug && !!ug.moveIn) {
            movein.push(`${ug.moveIn} (UG Halls)`);
        }
        if (!!pg && !!pg.moveIn) {
            movein.push(`${pg.moveIn} (PG Halls)`);
        }
        return movein.join(' or ');
    };


    const report_duty_desc_fn = (config: any) => {
        const {ug, pg} = config.eligible;
        const svr = [];
        if (!!ug && !!ug.svrPeriodStart) {
            svr.push(`${ug.svrPeriodStart} (UG Halls)`);
        }
        if (!!pg && !!pg.svrPeriodStart) {
            svr.push(`${pg.svrPeriodStart} (PG Halls)`);
        }
        return svr.join(' or ');
    };

    const eligibility_desc_fn = (config: any) => {
        const ed = [];
        if (!!config.eligible.pg) {
            ed.push('RPG');
        }
        if (!!config.eligible.ug) {
            ed.push('UG senior-year');
        }
        return ed.join(' and ');
    };

    return {
        ...config,
        move_in_period: move_in_period_fn(config),
        report_duty_desc: report_duty_desc_fn(config),
        eligiblie_desc: eligibility_desc_fn(config),
    };
};


// session store, load all application resource e.g. round, email, options etc
@Injectable({providedIn: 'root'})
export class SessionService {
    readonly activeRound = signal<Round | null>(null);
    private hasura = inject(KlntHasura);
    private auth = inject(AuthService);

    constructor() {
    }

    async loadApplicationResources() {
        console.log(this.auth.getCompound());
        const active: any = await this.loadActiveRound$(this.auth.getCompound());
        if (!!!active) {
            return false;
        }
        const curr = new Date();
        const open = new Date(active.appOpen);
        const close = new Date(active.appClose);
        active.appOpened = open <= curr && close >= curr;
        active.config = modifyConfig(active.config);
        this.activeRound.set(active);
        return true;
    }

    async successfulRound() {
        const apps = await this.hasura.select('rtapp_app', `
          whitelistTo whitelistFrom status result_close round
          `, {'status': {_eq: 'S'}});
        if (apps.length > 0) {
            const rounds = await this.hasura.select('rtapp_round',
                `appClose appOpen close id open refClose config compound`,
                {id: {_eq: apps[0].round}}
            );
            return rounds[0];
        }
        return null;
    }

    async loadActiveRound$(compound: string) {
        const success = await this.successfulRound();
        if (!!success) {
            return success;
        }
        const activeRounds = await this.hasura.select('rtapp_round',
            `appClose appOpen close id open refClose config compound`,
            {
                'open': {_lt: 'now()'},
                'close': {_gt: 'now()'},
                'compound': {_eq: compound},
            }, {'appClose': 'desc'});
        return firstElm(activeRounds);
    }

}
